<template>
  <div class="loader-overlay" v-show="loading">
    <div class="loader-container">
      <!-- Radio Station Antenna Animation -->
      <img src="./img/radio.svg" class="radio-antenna" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderComponent',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      text: 'Loading'
    }
  },
  methods: {
    showLoader(loadingText = 'Loading') {
      this.text = loadingText;
    }
  }
}
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 14, 38, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radio-antenna {
  width: 150px;
  height: 150px;
}
@media (max-width: 480px) {
  .radio-antenna {
    width: 120px;
    height: 120px;
  }
}
</style>